import { ImageAnnotation } from "@annotorious/react";
import { Box, Text } from "@chakra-ui/react";
import { getIssueColor, getIssueLabel } from "./health_issues";

interface AnnotationPopupProps {
  annotation: ImageAnnotation;
}

const AnnotationPopup: React.FC<AnnotationPopupProps> = ({ annotation }) => (
  <Box fontSize="xs">
    {annotation.bodies.length === 0 ? (
      <Text py="1" px="2" bg="gray.100" color="gray.700" border="2px solid">
        Unlabelled
      </Text>
    ) : (
      annotation.bodies.map((b) => (
        <Text
          py="1"
          px="2"
          mt="-1px"
          border="2px solid"
          bg={`${getIssueColor(b.id)}.100`}
          color={`${getIssueColor(b.id)}.700`}
          key={b.id}
        >
          {`${getIssueLabel(b.id)} (${Number(b.value).toFixed(3)})`}
        </Text>
      ))
    )}
  </Box>
);

export default AnnotationPopup;
